import { useQuery } from '@tanstack/react-query';
import { Endpoint } from '@/Config/api/endpoint';
import { AiApi } from '@/Domain/api/AI/Ai.api';

export const useScenarioUsers = () => {
  const { data, isLoading } = useQuery({
    queryKey: [Endpoint.ai.users],
    queryFn: () => AiApi.getUsers(),
  });

  return { users: data, isLoading };
};
